// import React, { useState, useEffect, useMemo } from 'react';
// import './VendorCare.css'; // Assuming we are removing custom CSS
// import { useLoader } from '../../../../context/LoaderProvider.jsx';

// const initialVendorIssues = [
//     {
//         id: 1,
//         name: 'Vendor One Supplies',
//         email: 'vendor1@example.com',
//         phone: '9999999999',
//         summary: 'Payment not received for invoice #INV001',
//         status: 'Pending',
//         dateSubmitted: '2025-05-27',
//         priority: 'High',
//         lastFollowUp: '2025-05-28',
//         assignedTo: 'Alice',
//     },
//     {
//         id: 2,
//         name: 'Vendor Two Tech',
//         email: 'vendor2@example.com',
//         phone: '8888888888',
//         summary: 'Unable to upload new product catalog via API. This is a longer summary to test how text wrapping behaves in the table and modal views. We need to ensure it looks good and does not break the layout.',
//         status: 'Escalated',
//         dateSubmitted: '2025-05-25',
//         priority: 'Urgent',
//         lastFollowUp: '2025-05-26',
//         assignedTo: 'Bob (Tech Lead)',
//     },
//     {
//         id: 3,
//         name: 'Vendor Three Logistics',
//         email: 'vendor3@example.com',
//         phone: '7777777777',
//         summary: 'Incorrect product mapping for SKU #XYZ123',
//         status: 'In Progress',
//         dateSubmitted: '2025-05-26',
//         priority: 'Medium',
//         lastFollowUp: '2025-05-29',
//         assignedTo: 'Carol',
//     },
//     {
//         id: 4,
//         name: 'Vendor Four Services',
//         email: 'vendor4@example.com',
//         phone: '6666666666',
//         summary: 'Contract renewal query',
//         status: 'Resolved',
//         dateSubmitted: '2025-05-20',
//         priority: 'Low',
//         lastFollowUp: '2025-05-22',
//         assignedTo: 'Alice',
//     },
// ];

// const STATUS_OPTIONS = ["OPEN", "IN_PROGRESS", "RESOLVED", "REJECTED"];
// const PRIORITY_OPTIONS = ['Low', 'Medium', 'High', 'Urgent'];
// const ASSIGNEE_OPTIONS = ['Unassigned', 'Alice', 'Bob (Tech Lead)', 'Carol', 'Support Team'];

// const MODAL_BACKGROUND_COLOR = '#f8f9fa';

// const Vendorcoustomercare = () => {
//     const [vendorIssues, setVendorIssues] = useState(initialVendorIssues);
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState('');
//     const [selectedPriorityFilter, setSelectedPriorityFilter] = useState('');
//     const [searchTerm, setSearchTerm] = useState('');
//     const { showLoader, hideLoader } = useLoader();
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [showViewModal, setShowViewModal] = useState(false);

//     const [currentIssueForView, setCurrentIssueForView] = useState(null);
//     const [formData, setFormData] = useState({});
//     // const [viewLoading, setViewLoading] = useState(false);
//     // const [newStatus, setNewStatus] = useState(""); // ✅ Required state
//     const defaultNewIssue = {
//         name: '', email: '', phone: '', summary: '',
//         status: STATUS_OPTIONS[0],
//         dateSubmitted: new Date().toISOString().split('T')[0],
//         priority: PRIORITY_OPTIONS[1],
//         lastFollowUp: new Date().toISOString().split('T')[0],
//         assignedTo: ASSIGNEE_OPTIONS[0],
//     };

//     const [vendorStats, setVendorStats] = useState({
//         OPEN: 0,
//         IN_PROGRESS: 0,
//         RESOLVED: 0,
//         REJECTED: 0,
//         Total: 0,
//     });


//     const [filteredAndSearchedVendors, setFilteredAndSearchedVendors] = useState([]);
//     //  const [filteredAndSearchedVendors, setFilteredAndSearchedVendors] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [selectedTicket, setSelectedTicket] = useState(null);


//     // const [responseMessage, setResponseMessage] = useState("");
//     useEffect(() => {
//         if (selectedTicket) {
//             setResponseMessage(selectedTicket.responseMessage || "");
//         }
//     }, [selectedTicket]);

//     const [newStatus, setNewStatus] = useState("OPEN");
//     const [adminResponse, setResponseMessage] = useState("");
//     const [viewLoading, setViewLoading] = useState(false);

//     useEffect(() => {
//         if (currentIssueForView) {
//             setNewStatus(currentIssueForView.status || "OPEN");
//             setResponseMessage(currentIssueForView.responseMessage || "");
//         }
//     }, [currentIssueForView]);

//     // const [adminResponse, setAdminResponse] = useState("");

//     const fetchVendorIssues = async () => {
//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             console.error("⚠️ Token is missing");
//             return;
//         }

//         try {
//             showLoader();
//             const response = await fetch("https://backend.maamaas.com/food/api/vendor-tickets/all", {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             });

//             if (!response.ok) {
//                 const errData = await response.json();
//                 console.error("❌ Failed to fetch:", errData);
//                 throw new Error(errData.message || "API error");
//             }

//             const data = await response.json();
//             setFilteredAndSearchedVendors(data);

//             // ✅ Count status
//             const counts = {
//                 OPEN: 0,
//                 IN_PROGRESS: 0,
//                 RESOLVED: 0,
//                 REJECTED: 0,
//                 Total: data.length
//             };

//             data.forEach(ticket => {
//                 if (counts.hasOwnProperty(ticket.status)) {
//                     counts[ticket.status]++;
//                 }
//             });

//             setVendorStats(counts); // ✅ Update status stats
//         } catch (err) {
//             console.error("⚠️ Network Error:", err.message);
//             setError("Server not reachable. Please try again later.");
//         } finally {
//             setLoading(false);
//             hideLoader();
//         }
//     };


//     const handleStatusChange = async (ticketId, newStatus, responseMessage) => {
//         // ✅ Get token from localStorage
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//             alert("❌ Authorization token not found. Please log in again.");
//             return;
//         }

//         if (!responseMessage || !responseMessage.trim()) {
//             alert("⚠️ Please enter a response message before submitting.");
//             return;
//         }

//         try {
//             // ✅ Build the URL with query parameters
//             const url = `https://backend.maamaas.com/food/api/vendor-tickets/respond/${ticketId}?responseMessage=${encodeURIComponent(
//                 responseMessage
//             )}&status=${newStatus}`;

//             // ✅ Send PUT request
//             const response = await fetch(url, {
//                 method: "PUT", // changed from PATCH → PUT
//                 headers: {
//                     Accept: "*/*",
//                     Authorization: `Bearer ${token}`,
//                 },
//             });

//             if (!response.ok) {
//                 const errorText = await response.text();
//                 console.error("❌ Request failed:", errorText);
//                 alert(`❌ Request failed: ${errorText}`);
//                 return;
//             }

//             const data = await response.json();
//             // console.log("✅ Ticket updated successfully:", data);
//             alert("✅ Ticket updated successfully!");
//             window.location.reload(); // optional: refresh page

//         } catch (error) {
//             console.error("❌ Error:", error);
//             alert("❌ Something went wrong while updating the ticket.");
//         }
//     };






//     useEffect(() => {
//         fetchVendorIssues();
//     }, []);

//     const handleShowAddModal = () => {
//         setFormData(defaultNewIssue);
//         setShowAddModal(true);
//     };
//     const handleCloseAddModal = () => setShowAddModal(false);

//     const handleShowEditModal = (issue) => {
//         setFormData({ ...issue });
//         setShowEditModal(true);
//     };
//     const handleCloseEditModal = () => setShowEditModal(false);

//     const handleShowViewModal = async (issue) => {
//         setShowViewModal(true);
//         setViewLoading(true);

//         const ticketId = issue.id;
//         const userId = issue.userId || issue.userID || issue.id;

//         try {
//             const token = localStorage.getItem("authToken");

//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/vendor-tickets/${ticketId}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error("Failed to fetch ticket by ID");
//             }

//             const data = await response.json();
//             // console.log("🎯 Ticket by ID:", data);

//             const ticket = Array.isArray(data) ? data[0] : data;
//             setCurrentIssueForView(ticket);

//             // ✅ Set adminResponse from ticket's existing response
//             setResponseMessage(ticket.adminResponse || ""); // fallback to empty string if null
//         } catch (error) {
//             console.error("❌ Error fetching ticket by ID:", error);
//             setCurrentIssueForView(null);
//             setResponseMessage(""); // clear on error
//         } finally {
//             setViewLoading(false);
//         }
//     };

//     const handleCloseViewModal = () => setShowViewModal(false);


//     const handleMarkResolved = (id) => {
//         setVendorIssues(prevIssues =>
//             prevIssues.map(issue =>
//                 issue.id === id ? { ...issue, status: 'Resolved', lastFollowUp: new Date().toISOString().split('T')[0] } : issue
//             )
//         );
//     };

//     const handleFormChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const handleAddIssueSave = (e) => {
//         e.preventDefault();
//         const newId = vendorIssues.length > 0 ? Math.max(...vendorIssues.map(i => i.id)) + 1 : 1;
//         setVendorIssues(prevIssues => [
//             { ...formData, id: newId, lastFollowUp: formData.lastFollowUp || new Date().toISOString().split('T')[0] },
//             ...prevIssues
//         ]);
//         handleCloseAddModal();
//     };

//     const handleEditIssueSave = (e) => {
//         e.preventDefault();
//         setVendorIssues(prevIssues =>
//             prevIssues.map(issue =>
//                 issue.id === formData.id ? { ...formData, lastFollowUp: formData.lastFollowUp || new Date().toISOString().split('T')[0] } : issue
//             )
//         );
//         handleCloseEditModal();
//     };



//     const getStatusBadgeClass = (status) => {
//         switch (status) {
//             case 'OPEN': return 'bg-warning text-dark';
//             case 'IN_PROGRESS': return 'bg-info text-dark';
//             case 'RESOLVED': return 'bg-success text-white';
//             case 'REJECTED': return 'bg-danger text-white';
//             default: return 'bg-light text-dark';
//         }
//     };
//     const getPriorityBadgeClass = (priority) => {
//         switch (priority) {
//             case 'Urgent': return 'bg-danger text-white';
//             case 'High': return 'bg-warning text-dark';
//             case 'Medium': return 'bg-info text-dark';
//             case 'Low': return 'bg-success text-white';
//             default: return 'bg-light text-dark';
//         }
//     };

//     const renderFormFields = () => (
//         <>
//             <div className="row mb-3">

//                 <div className="col-md-6">
//                     <label htmlFor="formName" className="form-label fw-medium">Vendor Name <span className="text-danger">*</span></label>
//                     <input type="text" className="form-control form-control-sm" id="formName" name="name" value={formData.name || ''} onChange={handleFormChange} required />
//                 </div>
//                 <div className="col-md-6">
//                     <label htmlFor="formEmail" className="form-label fw-medium">Email</label>
//                     <input type="email" className="form-control form-control-sm" id="formEmail" name="email" value={formData.email || ''} onChange={handleFormChange} />
//                 </div>
//             </div>
//             <div className="row mb-3">
//                 <div className="col-md-6">
//                     <label htmlFor="formPhone" className="form-label fw-medium">Phone</label>
//                     <input type="tel" className="form-control form-control-sm" id="formPhone" name="phone" value={formData.phone || ''} onChange={handleFormChange} />
//                 </div>
//                 <div className="col-md-6">
//                     <label htmlFor="formDateSubmitted" className="form-label fw-medium">Date Submitted <span className="text-danger">*</span></label>
//                     <input type="date" className="form-control form-control-sm" id="formDateSubmitted" name="dateSubmitted" value={formData.dateSubmitted || ''} onChange={handleFormChange} required />
//                 </div>
//             </div>
//             <div className="mb-3">
//                 <label htmlFor="formSummary" className="form-label fw-medium">Issue Summary <span className="text-danger">*</span></label>
//                 <textarea className="form-control form-control-sm" id="formSummary" name="summary" rows="3" value={formData.summary || ''} onChange={handleFormChange} required></textarea>
//             </div>
//             <div className="row mb-3">
//                 <div className="col-md-6">
//                     <label htmlFor="formStatus" className="form-label fw-medium">Status <span className="text-danger">*</span></label>
//                     <select className="form-select form-select-sm" id="formStatus" name="status" value={formData.status || ''} onChange={handleFormChange} required>
//                         {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
//                     </select>
//                 </div>
//                 <div className="col-md-6">
//                     <label htmlFor="formPriority" className="form-label fw-medium">Priority <span className="text-danger">*</span></label>
//                     <select className="form-select form-select-sm" id="formPriority" name="priority" value={formData.priority || ''} onChange={handleFormChange} required>
//                         {PRIORITY_OPTIONS.map(p => <option key={p} value={p}>{p}</option>)}
//                     </select>
//                 </div>
//             </div>
//             <div className="row">
//                 <div className="col-md-6">
//                     <label htmlFor="formAssignedTo" className="form-label fw-medium">Assigned To</label>
//                     <select className="form-select form-select-sm" id="formAssignedTo" name="assignedTo" value={formData.assignedTo || ''} onChange={handleFormChange}>
//                         {ASSIGNEE_OPTIONS.map(a => <option key={a} value={a}>{a}</option>)}
//                     </select>
//                 </div>
//                 <div className="col-md-6">
//                     <label htmlFor="formLastFollowUp" className="form-label fw-medium">Last Follow-Up</label>
//                     <input type="date" className="form-control form-control-sm" id="formLastFollowUp" name="lastFollowUp" value={formData.lastFollowUp || ''} onChange={handleFormChange} />
//                 </div>
//             </div>
//         </>
//     );

//     return (
//         <div className=" mt-4 mb-5">
//             {/* Stats Dashboard - Simplified for a single wrapping row */}
//             <div className="row row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 justify-content-start text-center mb-4 gy-3 p-3">
//                 {/* Using justify-content-start to align left if not filling the whole row */}

//                 {STATUS_OPTIONS.map(status => (
//                     <div className="col" key={`stat-${status}`}>
//                         <div className={`card h-100 text-white ${getStatusBadgeClass(status).split(' ')[0]}`}>
//                             <div className="card-body p-2">
//                                 <h6 className="card-title mb-0">{vendorStats[status] || 0}</h6>
//                                 <small className="card-text">{status}</small>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//                 <div className="col"> {/* Total card */}
//                     <div className="card h-100 text-white " style={{ backgroundColor: "rgb(153, 0, 255)" }}>
//                         <div className="card-body p-2">
//                             <h6 className="card-title mb-0">{vendorStats.Total || 0}</h6>
//                             <small className="card-text">Total  Issues</small>
//                         </div>
//                     </div>
//                 </div>
//             </div>



//             {/* Issues Table */}
//             <div className="table-responsive shadow-sm roror2">
//                 <table className=" table-hover table-bordered align-middle caption-top">
//                     <thead className="orrr" style={{ fontSize: '0.9rem', verticalAlign: 'middle' }}>
//                         <tr>
//                             <th className='p-2 text-center'>Vendor Id</th>
//                             {/* <th className='p-2 text-center'>Vendor Name</th> */}
//                             <th className='p-2 text-center'>Category</th>
//                             <th style={{ minWidth: '250px' }} className='p-2 text-center'>Summary</th>

//                             <th className='p-2 text-center'>Status</th>
//                             <th className="p-2 text-center">Assigned To</th>
//                             <th className='p-2 text-center'>Date</th>
//                             <th className='p-2 text-center'>Time</th>
//                             <th className='p-2 text-center'>Resolved At</th>
//                             <th className='p-2 text-center'>Response</th>
//                             <th style={{ minWidth: '130px' }} className='p-2 text-center'>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredAndSearchedVendors.length > 0 ? (
//                             filteredAndSearchedVendors.map((issue) => (
//                                 <tr key={issue.id} style={{ fontSize: '0.9rem' }}>
//                                     {/* <td className='p-2 text-center'>{issue.id}</td> */}
//                                     <td className='p-2 text-center'>{issue.vendorId || 'N/A'}</td>
//                                     <td className='p-2 text-center'><span className={`badge rounded-pill ${getPriorityBadgeClass(issue.ticketType)}`}>{issue.ticketType}</span></td>
//                                     <td className="text-break p-2 text-center" style={{ maxWidth: '300px' }}>{issue.message}</td>

//                                     <td className='p-2 text-center'><span className={`badge rounded-pill ${getStatusBadgeClass(issue.status)}`}>{issue.status}</span></td>
//                                     <td className="p-2 text-center">{issue.assignedTo || "Unassigned"}</td>
//                                     <td className="p-2 text-center">{new Date(issue.createdAt).toLocaleDateString()}</td>
//                                     <td className="p-2 text-center">{new Date(issue.createdAt).toLocaleTimeString()}</td>
//                                     <td className='p-2 text-center'>{issue.resolvedAt || 'N/A'}</td>
//                                     <td className='p-2 text-center'>{issue.adminResponse || 'N/A'}</td>
//                                     <td className='p-2 text-center'>
//                                         <div className="btn-group btn-group-sm" role="group" aria-label="Issue Actions">
//                                             <button type="button" className="btn btn-outline-info" onClick={() => handleShowViewModal(issue)}>View Details</button>
//                                             {/* <button type="button" className="btn btn-outline-warning" onClick={() => handleShowEditModal(issue)}>Edit Issue</button> */}
//                                             {/* {issue.status !== 'Resolved' && (
//                                                 <button type="button" className="btn btn-outline-success" onClick={() => handleMarkResolved(issue.id)}>Resolved</button>
//                                             )} */}
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="9" className="text-center p-4">
//                                     <h5 className="text-muted">No vendor issues found.</h5>
//                                     <p className="text-muted">Try adjusting your filters or search term.</p>
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Add/Edit Modal */}
//             {(showAddModal || showEditModal) && (
//                 <div className="modal fade show d-block bg-white zoz" tabIndex="-1">
//                     <div style={{ width: "-100px" }}>
//                         <div className="modal-dialog modal-dialog-centered modal-lg">
//                             {/* MODIFICATION HERE for modal background */}
//                             <div className="modal-content" style={{ border: "0px solid" }}>
//                                 <form onSubmit={showAddModal ? handleAddIssueSave : handleEditIssueSave}>
//                                     <div className="modal-header">
//                                         <h5 className="modal-title">
//                                             {showAddModal ? 'Add New Vendor Issue' : `Edit Vendor Issue (ID: ${formData.id})`}
//                                         </h5>
//                                         <button type="button" className="btn-close" onClick={showAddModal ? handleCloseAddModal : handleCloseEditModal} aria-label="Close"></button>
//                                     </div>
//                                     <div className="modal-body">
//                                         {renderFormFields()}
//                                     </div>
//                                     <div className="modal-footer">
//                                         <button type="button" className="btn btn-secondary" onClick={showAddModal ? handleCloseAddModal : handleCloseEditModal}>
//                                             <i className="bi bi-x-circle me-1"></i>Cancel
//                                         </button>
//                                         <button type="submit" className={`btn ${showAddModal ? 'btn-primary' : 'btn-warning'}`}>
//                                             <i className={`bi ${showAddModal ? 'bi-plus-circle' : 'bi-save'} me-1`}></i>
//                                             {showAddModal ? 'Save Issue' : 'Save Changes'}
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* View Details Modal */}
//             {showViewModal && (
//                 <div className="modal fade show d-block bg-white zoz" tabIndex="-1">
//                     <div className="modal-dialog modal-dialog-centered modal-lg">
//                         <div className="modal-content" style={{ border: "0px solid" }}>
//                             <div className="modal-header">
//                                 <h5 className="modal-title">
//                                     {viewLoading
//                                         ? "Loading Issue..."
//                                         : `Issue Details (ID: ${currentIssueForView?.id || "N/A"})`}
//                                 </h5>
//                                 <button
//                                     type="button"
//                                     className="btn-close"
//                                     onClick={handleCloseViewModal}
//                                     aria-label="Close"
//                                 ></button>
//                             </div>

//                             <div className="modal-body">
//                                 {viewLoading ? (
//                                     <p className="text-center text-muted">Fetching issue data...</p>
//                                 ) : currentIssueForView ? (
//                                     <dl className="row gy-2">
//                                         <dt className="col-sm-4 col-md-3 fw-semibold text-muted">Status:</dt>
//                                         <dd className="col-sm-8 col-md-9">
//                                             <div className="d-flex align-items-center gap-2">
//                                                 <select
//                                                     className="form-select form-select-sm"
//                                                     value={newStatus}
//                                                     onChange={(e) => setNewStatus(e.target.value)}
//                                                 >
//                                                     <option value="OPEN">Open</option>
//                                                     <option value="IN_PROGRESS">In Progress</option>
//                                                     <option value="RESOLVED">Resolved</option>
//                                                     <option value="REJECTED">Rejected</option>
//                                                 </select>
//                                             </div>
//                                         </dd>
//                                         <label>Response Message</label>
//                                         <input
//                                             type="text"
//                                             className="form-control form-control-sm"
//                                             placeholder="Enter response message"
//                                             value={adminResponse}
//                                             onChange={(e) => setResponseMessage(e.target.value)}
//                                         />


//                                     </dl>

//                                 ) : (
//                                     <p className="text-danger">Failed to load issue details.</p>
//                                 )}
//                             </div>

//                             <div className="modal-footer">
//                                 <button
//                                     type="button"
//                                     className="btn btn-primary"
//                                     onClick={() =>
//                                         handleStatusChange(
//                                             currentIssueForView?.id, // ticketId
//                                             newStatus,               // selected status
//                                             adminResponse            // pass response message here
//                                         )
//                                     }
//                                 >
//                                     <i className="bi bi-save me-1"></i>Save
//                                 </button>



//                                 <button
//                                     type="button"
//                                     className="btn btn-secondary"
//                                     onClick={handleCloseViewModal}
//                                 >
//                                     <i className="bi bi-x-lg me-1"></i>Close
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Vendorcoustomercare;





























import React, { useState, useEffect, useMemo } from "react";
import "./VendorCare.css";
import { Link } from "react-router-dom";

const STATUS_OPTIONS = ["OPEN", "IN_PROGRESS", "RESOLVED", "REJECTED"];
const ADMIN_RESPONSE_OPTIONS = [
    "PENDING_REVIEW",
    "UNDER_INVESTIGATION",
    "RESOLVED_REFUNDED",
    "RESOLVED_REPLACED",
    "RESOLVED_COMPENSATED",
    "REJECTED_INVALID",
    "REJECTED_POLICY",
    "ESCALATED"
];

const Vendorcoustomercare = () => {
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedTicketTypeFilter, setSelectedTicketTypeFilter] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [showViewModal, setShowViewModal] = useState(false);
    const [vendorStats, setVendorStats] = useState({});
    const [currentIssueForView, setCurrentIssueForView] = useState(null);
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [viewLoading, setViewLoading] = useState(false);
    const [newStatus, setNewStatus] = useState("");
    const [adminResponse, setAdminResponse] = useState("");
    const [additionalNotes, setAdditionalNotes] = useState("");
    const [saving, setSaving] = useState(false);
    const [localAdminResponses, setLocalAdminResponses] = useState({});
    const [imagePreviewModal, setImagePreviewModal] = useState({ show: false, url: "" });
    const [imageFiles, setImageFiles] = useState([]);
    const [imagePreviewUrls, setImagePreviewUrls] = useState([]);

    // Handle body overflow when modals are open
    useEffect(() => {
        if (showViewModal || imagePreviewModal.show) {
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '0px';
        } else {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
        }

        return () => {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
        };
    }, [showViewModal, imagePreviewModal.show]);

    const handleStatusChange = async (ticketId, newStatus, adminResponse) => {
        try {
            const token = localStorage.getItem("authToken");

            // Build the URL with query parameters for vendor tickets API
            const url = `https://backend.maamaas.com/food/api/vendor-tickets/respond/${ticketId}?responseMessage=${encodeURIComponent(adminResponse)}&status=${newStatus}`;

            console.log("Updating vendor ticket with URL:", url);

            const response = await fetch(url, {
                method: "PUT",
                headers: {
                    Accept: "*/*",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("❌ API Error:", errorText);

                // Try with FormData if query params fail
                try {
                    const formData = new FormData();
                    formData.append('responseMessage', adminResponse);
                    formData.append('status', newStatus);

                    const formResponse = await fetch(`https://backend.maamaas.com/food/api/vendor-tickets/respond/${ticketId}`, {
                        method: "PUT",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        body: formData
                    });

                    if (!formResponse.ok) {
                        throw new Error(`Failed to update vendor ticket: ${errorText}`);
                    }

                    const data = await formResponse.json();
                    console.log("✅ Vendor ticket updated successfully:", data);

                    return {
                        success: true,
                        data: data
                    };
                } catch (formError) {
                    throw new Error(`Failed to update vendor ticket: ${formError.message}`);
                }
            }

            const updatedIssue = await response.json();
            console.log("✅ Vendor ticket updated successfully:", updatedIssue);

            setCurrentIssueForView((prev) => ({
                ...prev,
                status: updatedIssue.status || newStatus,
                adminResponse: updatedIssue.adminResponse || adminResponse || prev?.adminResponse
            }));

            return {
                success: true,
                data: updatedIssue
            };

        } catch (error) {
            console.error("Error updating vendor ticket status:", error);
            return {
                success: false,
                error: error.message
            };
        }
    };

    const storeAdminResponseLocally = (ticketId, response, notes = "") => {
        setLocalAdminResponses(prev => ({
            ...prev,
            [ticketId]: {
                response,
                notes,
                timestamp: new Date().toISOString(),
                adminName: localStorage.getItem("userName") || "Admin"
            }
        }));
        return true;
    };

    const getCombinedAdminResponse = (ticket) => {
        const localResponse = localAdminResponses[ticket.id];
        if (localResponse) {
            return {
                response: localResponse.response,
                notes: localResponse.notes,
                isLocal: true,
                timestamp: localResponse.timestamp,
                adminName: localResponse.adminName
            };
        }
        return {
            response: ticket.adminResponse,
            notes: "",
            isLocal: false,
            timestamp: ticket.resolvedAt || ticket.createdAt
        };
    };

    useEffect(() => {
        fetchTickets();
        // Load locally stored responses
        const savedResponses = localStorage.getItem("localAdminResponses");
        if (savedResponses) {
            setLocalAdminResponses(JSON.parse(savedResponses));
        }
    }, []);

    useEffect(() => {
        // Save locally stored responses
        localStorage.setItem("localAdminResponses", JSON.stringify(localAdminResponses));
    }, [localAdminResponses]);

    const fetchTickets = async () => {
        setLoading(true);
        setError("");

        try {
            const token = localStorage.getItem("authToken");
            const res = await fetch(
                "https://backend.maamaas.com/food/api/vendor-tickets/all",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!res.ok) throw new Error("Failed to fetch vendor tickets");

            const data = await res.json();
            console.log("🎫 Vendor tickets fetched:", data);
            setTickets(data);

            // Calculate statistics
            const counts = {
                OPEN: 0,
                IN_PROGRESS: 0,
                RESOLVED: 0,
                REJECTED: 0,
                Total: 0
            };

            data.forEach(ticket => {
                const status = ticket.status || "UNKNOWN";
                if (STATUS_OPTIONS.includes(status)) {
                    counts[status] = (counts[status] || 0) + 1;
                }
            });
            counts.Total = data.length;

            setVendorStats(counts);
        } catch (err) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const handleShowViewModal = async (ticket) => {
        setShowViewModal(true);
        setViewLoading(true);
        setAdminResponse("");
        setNewStatus("");
        setAdditionalNotes("");
        setImageFiles([]);
        setImagePreviewUrls([]);

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(
                `https://backend.maamaas.com/food/api/vendor-tickets/${ticket.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch vendor ticket details");
            }

            const data = await response.json();
            console.log("🎯 Vendor ticket details:", data);

            // Handle array or single object response
            const ticketData = Array.isArray(data) ? data[0] : data;
            setCurrentIssueForView(ticketData);
            setAdminResponse(ticketData.adminResponse || "");
            setNewStatus(ticketData.status || "");

            // Use attachmentUrl if it exists
            if (ticketData.attachmentUrl) {
                setImagePreviewUrls([ticketData.attachmentUrl]);
            }
        } catch (error) {
            console.error("❌ Error fetching vendor ticket details:", error);
            setCurrentIssueForView(ticket);
        } finally {
            setViewLoading(false);
        }
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setCurrentIssueForView(null);
        setAdminResponse("");
        setNewStatus("");
        setAdditionalNotes("");
        setSaving(false);
        setImageFiles([]);
        setImagePreviewUrls([]);
    };

    const showImagePreview = (url) => {
        setImagePreviewModal({ show: true, url });
    };

    const closeImagePreview = () => {
        setImagePreviewModal({ show: false, url: "" });
    };

    const filteredTickets = useMemo(() => {
        return tickets.filter(ticket => {
            const matchesStatus = !selectedStatusFilter || ticket.status === selectedStatusFilter;
            const matchesType = !selectedTicketTypeFilter || ticket.ticketType === selectedTicketTypeFilter;
            const matchesSearch = !searchTerm ||
                (ticket.message && ticket.message.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (ticket.id && ticket.id.toString().includes(searchTerm)) ||
                (ticket.vendorId && ticket.vendorId.toString().includes(searchTerm));

            return matchesStatus && matchesType && matchesSearch;
        }).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }, [tickets, selectedStatusFilter, selectedTicketTypeFilter, searchTerm]);

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case "OPEN":
                return "bg-warning text-dark";
            case "IN_PROGRESS":
                return "bg-info text-dark";
            case "RESOLVED":
                return "bg-success text-white";
            case "REJECTED":
                return "bg-danger text-white";
            default:
                return "bg-secondary text-white";
        }
    };

    const getTicketTypeBadgeClass = (ticketType) => {
        switch (ticketType) {
            case "SERVICE_QUALITY":
                return "bg-primary text-white";
            case "FOOD_QUALITY":
                return "bg-success text-white";
            case "DELIVERY_ISSUE":
                return "bg-warning text-dark";
            case "PAYMENT_PROBLEM":
                return "bg-danger text-white";
            case "OTHER":
                return "bg-secondary text-white";
            default:
                return "bg-dark text-white";
        }
    };

    const getAdminResponseBadgeClass = (response) => {
        if (!response) return "bg-light text-dark";

        if (response.includes("RESOLVED")) return "bg-success text-white";
        if (response.includes("REJECTED")) return "bg-danger text-white";
        if (response.includes("PENDING") || response.includes("UNDER_INVESTIGATION")) return "bg-warning text-dark";
        if (response === "ESCALATED") return "bg-info text-dark";

        return "bg-secondary text-white";
    };

    const formatTicketType = (ticketType) => {
        return ticketType ? ticketType.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : "Unknown";
    };

    const formatAdminResponse = (response) => {
        if (!response) return "No Response";
        return response.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        setImageFiles(prev => [...prev, ...files]);

        // Create preview URLs
        const newPreviewUrls = files.map(file => URL.createObjectURL(file));
        setImagePreviewUrls(prev => [...prev, ...newPreviewUrls]);
    };

    const removeImage = (index) => {
        // Revoke the object URL to prevent memory leaks
        URL.revokeObjectURL(imagePreviewUrls[index]);

        setImageFiles(prev => prev.filter((_, i) => i !== index));
        setImagePreviewUrls(prev => prev.filter((_, i) => i !== index));
    };

    const handleSaveChanges = async () => {
        if (!newStatus && !adminResponse) {
            alert("Please update status or add a response");
            return;
        }

        setSaving(true);
        let messages = [];

        try {
            // Handle status update
            if (currentIssueForView) {
                const result = await handleStatusChange(
                    currentIssueForView.id,
                    newStatus || currentIssueForView.status,
                    adminResponse || ""
                );

                if (result.success) {
                    if (newStatus) {
                        messages.push(`Status updated to ${newStatus}`);
                    }

                    if (adminResponse) {
                        messages.push(`Admin response updated to ${formatAdminResponse(adminResponse)}`);
                    }
                } else {
                    messages.push(`Failed to update: ${result.error}`);
                }
            }

            // Refresh tickets
            await fetchTickets();

            // Show success message
            if (messages.length > 0) {
                alert("✅ " + messages.join("\n"));
            }

            handleCloseViewModal();

        } catch (error) {
            console.error("Error saving changes:", error);
            alert("Failed to save changes: " + error.message);
        } finally {
            setSaving(false);
        }
    };

    const renderFilterControls = () => (
        <div className="row mb-3">
            {/* Add filter controls if needed */}
        </div>
    );

    return (
        <div className="container-fluid mt-4 mb-5">
            {/* Stats Dashboard Row */}
            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 justify-content-start text-center mb-4 gy-3 p-3">
                {STATUS_OPTIONS.map((status) => (
                    <div className="col" key={`stat-${status}`}>
                        <div
                            className={`card h-100 text-white ${getStatusBadgeClass(status).split(" ")[0]}`}
                        >
                            <div className="card-body p-2">
                                <h6 className="card-title mb-0">{vendorStats[status] || 0}</h6>
                                <small className="card-text">{status}</small>
                            </div>
                        </div>
                    </div>
                ))}
                <div className="col">
                    <div
                        className="card h-100 text-white"
                        style={{ backgroundColor: "rgb(153, 0, 255)" }}
                    >
                        <div className="card-body p-2">
                            <h6 className="card-title mb-0">{vendorStats.Total || 0}</h6>
                            <small className="card-text">Total Tickets</small>
                        </div>
                    </div>
                </div>
            </div>

            {/* Warning about local storage if we have local responses */}
            {Object.keys(localAdminResponses).length > 0 && (
                <div className="alert alert-info mb-3">
                    <i className="bi bi-info-circle me-2"></i>
                    <strong>Note:</strong> Some admin responses are stored locally because the API doesn't support the adminResponse field. These will be preserved in your browser's local storage.
                </div>
            )}

            {/* Filter Controls */}
            {renderFilterControls()}

            {/* Issues Table */}
            <div className="table-responsive shadow-sm rounded">
                <table className="table table-hover table-bordered align-middle caption-top">
                    <thead style={{ fontSize: "0.9rem", verticalAlign: "middle" }}>
                        <tr>
                            <th style={tableHeaderStyle} className="p-2">Ticket ID</th>
                            <th style={tableHeaderStyle} className="p-2">Vendor ID</th>
                            <th style={tableHeaderStyle} className="p-2">Type</th>
                            <th style={{ ...tableHeaderStyle, minWidth: "200px" }} className="p-2">Message</th>
                            <th style={tableHeaderStyle} className="p-2">Status</th>
                            <th style={tableHeaderStyle} className="p-2">Reported Date</th>
                            <th style={tableHeaderStyle} className="p-2">Reported Time</th>
                            <th style={tableHeaderStyle} className="p-2">Resolved At</th>
                            <th style={tableHeaderStyle} className="p-2">Admin Response</th>
                            <th style={tableHeaderStyle} className="p-2">Image</th>
                            <th style={{ ...tableHeaderStyle, minWidth: "130px" }} className="p-2">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="11" className="text-center p-4">Loading tickets...</td>
                            </tr>
                        ) : error ? (
                            <tr>
                                <td colSpan="11" className="text-center p-4 text-danger">{error}</td>
                            </tr>
                        ) : filteredTickets.length > 0 ? (
                            filteredTickets.map((ticket) => {
                                const combinedResponse = getCombinedAdminResponse(ticket);

                                return (
                                    <tr key={ticket.id} style={{ fontSize: "0.9rem" }}>
                                        <td style={tableCellStyle} className="p-2">{ticket.id}</td>
                                        <td style={tableCellStyle} className="p-2">
                                            {ticket.vendorId ? (
                                                <Link to={`/vendor-profile/${ticket.vendorId}`} className="text-decoration-none">
                                                    {ticket.vendorId}
                                                </Link>
                                            ) : "N/A"}
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            <span className={`badge rounded-pill ${getTicketTypeBadgeClass(ticket.ticketType)}`}>
                                                {formatTicketType(ticket.ticketType)}
                                            </span>
                                        </td>
                                        <td style={{ ...tableCellStyle }} className="text-break p-2">
                                            {ticket.message || "No message"}
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            <span className={`badge rounded-pill ${getStatusBadgeClass(ticket.status)}`}>
                                                {ticket.status || "UNKNOWN"}
                                            </span>
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            {ticket.createdAt ? new Date(ticket.createdAt).toLocaleDateString() : "N/A"}
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            {ticket.createdAt ? new Date(ticket.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "N/A"}
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            {ticket.resolvedAt ? new Date(ticket.resolvedAt).toLocaleDateString() : 'N/A'}
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            <div>
                                                <span className={`badge rounded-pill ${getAdminResponseBadgeClass(combinedResponse.response)}`}>
                                                    {formatAdminResponse(combinedResponse.response)}
                                                    {combinedResponse.isLocal && (
                                                        <span className="ms-1" title="Stored locally">
                                                            <i className="bi bi-device-ssd"></i>
                                                        </span>
                                                    )}
                                                </span>
                                                {combinedResponse.isLocal && (
                                                    <small className="d-block text-muted mt-1">
                                                        Local: {new Date(combinedResponse.timestamp).toLocaleDateString()}
                                                    </small>
                                                )}
                                            </div>
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            {ticket.attachmentUrl ? (
                                                <div className="image-thumbnail-container" style={{ width: "80px", height: "60px" }}>
                                                    <img
                                                        src={ticket.attachmentUrl}
                                                        alt="Ticket attachment"
                                                        className="img-thumbnail cursor-pointer"
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => showImagePreview(ticket.attachmentUrl)}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = 'https://via.placeholder.com/80x60?text=No+Image';
                                                            e.target.style.objectFit = "contain";
                                                            e.target.style.padding = "5px";
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <span className="text-muted">No Image</span>
                                            )}
                                        </td>
                                        <td style={tableCellStyle} className="p-2">
                                            <div className="btn-group btn-group-sm" role="group">
                                                <button
                                                    className="btn btn-outline-primary"
                                                    onClick={() => handleShowViewModal(ticket)}
                                                >
                                                    View
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="11" className="text-center p-4">
                                    <h5 className="text-muted">No tickets found.</h5>
                                    <p className="text-muted">
                                        {tickets.length === 0
                                            ? "No support tickets have been created yet."
                                            : "No tickets match your filters."}
                                    </p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Image Preview Modal */}
            {imagePreviewModal.show && (
                <div className="modal-overlay-fixed" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }}>
                    <div className="modal-dialog modal-dialog-centered modal-xl" style={{
                        zIndex: 10000,
                        width: '100%',
                        maxWidth: '1200px'
                    }}>
                        <div className="modal-content bg-transparent border-0 shadow-lg">
                            <div className="modal-header border-0">
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={closeImagePreview}
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body text-center">
                                <img
                                    src={imagePreviewModal.url}
                                    alt="Full size preview"
                                    className="img-fluid rounded"
                                    style={{
                                        maxHeight: '80vh',
                                        maxWidth: '100%',
                                        boxShadow: '0 5px 20px rgba(0,0,0,0.3)'
                                    }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://via.placeholder.com/800x600?text=Image+Not+Available';
                                    }}
                                />
                                <div className="mt-4">
                                    <a
                                        href={imagePreviewModal.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-primary me-3 px-4 py-2"
                                        style={{ borderRadius: '8px' }}
                                    >
                                        <i className="bi bi-box-arrow-up-right me-2"></i>Open in New Tab
                                    </a>
                                    <a
                                        href={imagePreviewModal.url}
                                        download
                                        className="btn btn-secondary px-4 py-2"
                                        style={{ borderRadius: '8px' }}
                                    >
                                        <i className="bi bi-download me-2"></i>Download
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* View Details Modal */}
            {showViewModal && (
                <div className="modal-overlay-fixed" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    zIndex: 9998,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }}>
                    <div className="modal-dialog modal-dialog-centered" style={{
                        zIndex: 9999,
                        width: '100%',
                        maxWidth: '600px',
                        margin: '0 auto'
                    }}>
                        <div className="modal-content" style={{
                            borderRadius: '10px',
                            boxShadow: '0 8px 25px rgba(0,0,0,0.3)',
                            border: 'none',
                            maxHeight: '85vh',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            {/* Modal Header */}
                            <div className="modal-header text-white" style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderBottom: 'none',
                                padding: '1rem 1.2rem',
                                flexShrink: 0
                            }}>
                                <h5 className="modal-title fw-bold mb-0" style={{ fontSize: '1rem' }}>
                                    <i className="bi bi-ticket-detailed me-1"></i>
                                    {viewLoading ? "Loading Ticket..." : `Ticket #${currentIssueForView?.id || "N/A"}`}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={handleCloseViewModal}
                                    aria-label="Close"
                                    style={{
                                        filter: 'brightness(0) invert(1)',
                                        fontSize: '0.7rem'
                                    }}
                                ></button>
                            </div>

                            <div className="modal-body" style={{
                                padding: '1.2rem',
                                backgroundColor: '#f8f9fa',
                                overflowY: 'auto',
                                flex: 1
                            }}>
                                {viewLoading ? (
                                    <div className="text-center py-3">
                                        <div className="spinner-border text-primary" style={{ width: '2rem', height: '2rem' }} role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.9rem' }}>Fetching ticket details...</p>
                                    </div>
                                ) : currentIssueForView ? (
                                    <>
                                        {/* Compact Ticket Info Row */}
                                        <div className="row mb-3">
                                            <div className="col-6 mb-2">
                                                <div className="p-2 bg-light rounded border">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Ticket ID</small>
                                                    <strong className="d-block" style={{ fontSize: '0.85rem' }}>{currentIssueForView.id}</strong>
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="p-2 bg-light rounded border">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Type</small>
                                                    <span className={`badge ${getTicketTypeBadgeClass(currentIssueForView.ticketType)} px-2 py-1`} style={{ fontSize: '0.75rem' }}>
                                                        {formatTicketType(currentIssueForView.ticketType)}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="p-2 bg-light rounded border">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Vendor ID</small>
                                                    <strong className="d-block" style={{ fontSize: '0.85rem' }}>
                                                        {currentIssueForView.vendorId ? (
                                                            <Link to={`/vendor-profile/${currentIssueForView.vendorId}`} className="text-decoration-none text-primary">
                                                                {currentIssueForView.vendorId}
                                                            </Link>
                                                        ) : "N/A"}
                                                    </strong>
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="p-2 bg-light rounded border">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Current Status</small>
                                                    <span className={`badge ${getStatusBadgeClass(currentIssueForView.status)} px-2 py-1`} style={{ fontSize: '0.75rem' }}>
                                                        {currentIssueForView.status}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Timestamps */}
                                        {/* Timestamps */}
                                        <div className="row mb-3">
                                            <div className="col-6">
                                                <div className="p-2 bg-light rounded border">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Created</small>
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-calendar-plus me-1" style={{ fontSize: '0.8rem' }}></i>
                                                        <span style={{ fontSize: '0.8rem', marginLeft: "75px" }}>
                                                            {currentIssueForView.createdAt ?
                                                                new Date(currentIssueForView.createdAt).toLocaleDateString('en-GB') :
                                                                "N/A"}
                                                        </span>
                                                    </div>
                                                    <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                                                        {currentIssueForView.createdAt ?
                                                            new Date(currentIssueForView.createdAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }) :
                                                            ""}
                                                    </small>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="p-2 bg-light rounded border">
                                                    <small className="text-muted d-block" style={{ fontSize: '0.7rem' }}>Resolved</small>
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-check-circle me-1" style={{ fontSize: '0.8rem' }}></i>
                                                        <span style={{ fontSize: '0.8rem', marginLeft: "75px" }}>
                                                            {currentIssueForView.resolvedAt ?
                                                                new Date(currentIssueForView.resolvedAt).toLocaleDateString('en-GB') :
                                                                'Not resolved'}
                                                        </span>
                                                    </div>
                                                    {currentIssueForView.resolvedAt && (
                                                        <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                                                            {new Date(currentIssueForView.resolvedAt).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                                        </small>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Issue Description */}
                                        <div className="mb-3">
                                            <h6 className="fw-bold text-primary mb-2" style={{ fontSize: '0.9rem' }}>
                                                <i className="bi bi-chat-left-text me-1"></i>
                                                Issue Description
                                            </h6>
                                            <div className="p-3 bg-light rounded border">
                                                <p className="mb-0" style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>
                                                    {currentIssueForView.message || "No description provided"}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Current Admin Response */}
                                        <div className="mb-3">
                                            <h6 className="fw-bold text-primary mb-2" style={{ fontSize: '0.9rem' }}>
                                                <i className="bi bi-person-badge me-1"></i>
                                                Current Response
                                            </h6>
                                            <div className="text-center">
                                                {currentIssueForView.adminResponse || localAdminResponses[currentIssueForView.id] ? (
                                                    <div>
                                                        <span className={`badge ${getAdminResponseBadgeClass(
                                                            localAdminResponses[currentIssueForView.id]?.response ||
                                                            currentIssueForView.adminResponse
                                                        )} px-3 py-2 mb-2`} style={{
                                                            fontSize: '0.8rem'
                                                        }}>
                                                            {formatAdminResponse(
                                                                localAdminResponses[currentIssueForView.id]?.response ||
                                                                currentIssueForView.adminResponse
                                                            )}
                                                            {localAdminResponses[currentIssueForView.id] && (
                                                                <span className="ms-1" title="Stored locally">
                                                                    <i className="bi bi-device-ssd"></i>
                                                                </span>
                                                            )}
                                                        </span>
                                                        {localAdminResponses[currentIssueForView.id]?.notes && (
                                                            <div className="alert alert-info p-2 mt-2 mb-2" style={{ fontSize: '0.8rem' }}>
                                                                <strong>Notes:</strong> {localAdminResponses[currentIssueForView.id].notes}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="text-muted p-3 bg-light rounded">
                                                        <i className="bi bi-chat-square-text me-1"></i>
                                                        No response yet
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Image Attachment - Only show if exists */}
                                        {currentIssueForView.attachmentUrl && (
                                            <div className="mb-3">
                                                <h6 className="fw-bold text-primary mb-2" style={{ fontSize: '0.9rem' }}>
                                                    <i className="bi bi-image me-1"></i>
                                                    Attachment
                                                </h6>
                                                <div className="text-center">
                                                    <div className="mb-2">
                                                        <img
                                                            src={currentIssueForView.attachmentUrl}
                                                            alt="Ticket attachment"
                                                            className="img-fluid rounded border"
                                                            style={{
                                                                maxHeight: '120px',
                                                                maxWidth: '100%'
                                                            }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://via.placeholder.com/200x120?text=Image';
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <a
                                                            href={currentIssueForView.attachmentUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-primary btn-sm me-1"
                                                            style={{ fontSize: '0.8rem', padding: '0.25rem 0.75rem' }}
                                                        >
                                                            <i className="bi bi-box-arrow-up-right me-1"></i>Open
                                                        </a>
                                                        <a
                                                            href={currentIssueForView.attachmentUrl}
                                                            download
                                                            className="btn btn-outline-secondary btn-sm"
                                                            style={{ fontSize: '0.8rem', padding: '0.25rem 0.75rem' }}
                                                        >
                                                            <i className="bi bi-download me-1"></i>Download
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Update Section - Single Row */}
                                        <div className="row mt-3">
                                            <div className="col-6">
                                                <h6 className="fw-bold text-primary mb-2" style={{ fontSize: '0.9rem' }}>
                                                    <i className="bi bi-arrow-clockwise me-1"></i>
                                                    Status
                                                </h6>
                                                <select
                                                    className="form-select form-select-sm mb-2"
                                                    value={newStatus}
                                                    onChange={(e) => setNewStatus(e.target.value)}
                                                    style={{ fontSize: '0.85rem' }}
                                                >
                                                    <option value="">Select status</option>
                                                    {STATUS_OPTIONS.map(status => (
                                                        <option key={status} value={status}>{status}</option>
                                                    ))}
                                                </select>
                                                <div className="d-flex align-items-center">
                                                    <small className="text-muted me-2" style={{ fontSize: '0.8rem' }}>Current:</small>
                                                    <span className={`badge ${getStatusBadgeClass(currentIssueForView.status)}`} style={{ fontSize: '0.75rem' }}>
                                                        {currentIssueForView.status}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <h6 className="fw-bold text-primary mb-2" style={{ fontSize: '0.9rem' }}>
                                                    <i className="bi bi-reply me-1"></i>
                                                    Response
                                                </h6>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={adminResponse}
                                                    onChange={(e) => setAdminResponse(e.target.value)}
                                                    style={{ fontSize: '0.85rem' }}
                                                >
                                                    <option value="">Select response</option>
                                                    {ADMIN_RESPONSE_OPTIONS.map(response => (
                                                        <option key={response} value={response}>{formatAdminResponse(response)}</option>
                                                    ))}
                                                </select>
                                                {adminResponse && (
                                                    <small className="text-warning d-block mt-1" style={{ fontSize: '0.7rem' }}>
                                                        <i className="bi bi-info-circle me-1"></i>
                                                        Stored locally
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="text-center py-4">
                                        <i className="bi bi-exclamation-triangle text-danger mb-2" style={{ fontSize: '1.5rem' }}></i>
                                        <p className="text-danger mb-0" style={{ fontSize: '0.9rem' }}>Failed to load ticket details</p>
                                    </div>
                                )}
                            </div>

                            {/* Modal Footer - Compact */}
                            <div className="modal-footer border-top-0 py-2 px-3" style={{
                                background: '#f8f9fa',
                                flexShrink: 0,
                                gap: "30px"
                            }}>
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    onClick={handleCloseViewModal}
                                    disabled={saving}
                                    style={{
                                        fontSize: '0.85rem',
                                        padding: '0.375rem 0.75rem'
                                    }}
                                >
                                    <i className="bi bi-x-lg me-1"></i>Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    onClick={handleSaveChanges}
                                    disabled={(!newStatus && !adminResponse) || saving}
                                    style={{
                                        fontSize: '0.85rem',
                                        padding: '0.375rem 0.75rem'
                                    }}
                                >
                                    {saving ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                            Saving
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-save me-1"></i>Save
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const tableHeaderStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
    fontWeight: 'bold',
    backgroundColor: '#b15cd6',
    color: 'white',
    minWidth: '95px'
};

const tableCellStyle = {
    border: '1px solid #ddd',
    textAlign: 'center',
    verticalAlign: 'middle'
};

export default Vendorcoustomercare;